import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import HRDashboard from './hr/HRDashboard';
import EmployeeMaster from './hr/EmployeeMaster';
import OrgChart from './hr/OrgChart';
import AttendanceLeave from './hr/AttendanceLeave';
import AttendanceAnomalies from './hr/AttendanceAnomalies';
import Payroll from './hr/Payroll';
import Onboarding from './hr/Onboarding';
import ExitManagement from './hr/ExitManagement';
import DocumentVault from './hr/DocumentVault';
import Shifts from './hr/Shifts';
import HolidayCalendar from './hr/HolidayCalendar';
import LeavePolicies from './hr/LeavePolicies';
import ApprovalsCenter from './hr/ApprovalsCenter';
import MyProfile from './hr/MyProfile';
import CTCStructure from './hr/CTCStructure';
import SalaryStructureMaster from './hr/SalaryStructureMaster';
import Reimbursements from './hr/Reimbursements';
import ITDeclaration from './hr/ITDeclaration';
import StatutoryRegisters from './hr/StatutoryRegisters';
import HRLetters from './hr/HRLetters';
import PMS from './hr/PMS';
import Policies from './hr/Policies';
import MarriageGift from './hr/MarriageGift';
import Referrals from './hr/Referrals';
import ApplyLeave from './hr/ApplyLeave';
import RecruitmentDashboard from './hr/recruitment/RecruitmentDashboard';
import JobOpenings from './hr/recruitment/JobOpenings';
import JobDetail from './hr/recruitment/JobDetail';
import CandidateDetail from './hr/recruitment/CandidateDetail';
import TrainingDashboard from './hr/training/TrainingDashboard';
import TrainingPlanDetail from './hr/training/TrainingPlanDetail';
import MyTraining from './hr/training/MyTraining';
import AssetDashboard from './hr/assets/AssetDashboard';
import AssetRegister from './hr/assets/AssetRegister';
import MyAssets from './hr/assets/MyAssets';
import VisitorLog from './hr/visitors/VisitorLog';
import TravelDashboard from './hr/travel/TravelDashboard';
import TravelRequests from './hr/travel/TravelRequests';
import TravelRequestDetail from './hr/travel/TravelRequestDetail';
import MyTravel from './hr/travel/MyTravel';
import ComplianceDashboard from './hr/ComplianceDashboard';
import ComplianceInsurance from './hr/ComplianceInsurance';
import ComplianceStatutory from './hr/ComplianceStatutory';
import ComplianceVault from './hr/ComplianceVault';

export default function HR() {
  return (
    <div data-testid="hr-page">
      <Routes>
        <Route index element={<Navigate to="dashboard" replace />} />
        <Route path="dashboard" element={<HRDashboard />} />
        <Route path="me" element={<MyProfile />} />
        <Route path="my-profile" element={<MyProfile />} />
        <Route path="apply-leave" element={<ApplyLeave />} />
        <Route path="employees" element={<EmployeeMaster />} />
        <Route path="org-chart" element={<OrgChart />} />
        <Route path="onboarding" element={<Onboarding />} />
        <Route path="documents" element={<DocumentVault />} />
        <Route path="attendance" element={<AttendanceLeave />} />
        <Route path="attendance-anomalies" element={<AttendanceAnomalies />} />
        <Route path="approvals" element={<ApprovalsCenter />} />
        <Route path="shifts" element={<Shifts />} />
        <Route path="holidays" element={<HolidayCalendar />} />
        <Route path="leave-policies" element={<LeavePolicies />} />
        <Route path="payroll" element={<Payroll />} />
        <Route path="salary-master" element={<SalaryStructureMaster />} />
        <Route path="ctc" element={<CTCStructure />} />
        <Route path="reimbursements" element={<Reimbursements />} />
        <Route path="it-declaration" element={<ITDeclaration />} />
        <Route path="statutory" element={<StatutoryRegisters />} />
        <Route path="compliance" element={<ComplianceDashboard />} />
        <Route path="compliance/insurance" element={<ComplianceInsurance />} />
        <Route path="compliance/statutory" element={<ComplianceStatutory />} />
        <Route path="compliance/vault" element={<ComplianceVault />} />
        <Route path="letters" element={<HRLetters />} />
        <Route path="pms" element={<PMS />} />
        <Route path="policies" element={<Policies />} />
        <Route path="marriage-gift" element={<MarriageGift />} />
        <Route path="referrals" element={<Referrals />} />
        <Route path="exit" element={<ExitManagement />} />
        <Route path="recruitment" element={<RecruitmentDashboard />} />
        <Route path="recruitment/jobs" element={<JobOpenings />} />
        <Route path="recruitment/jobs/:jobId" element={<JobDetail />} />
        <Route path="recruitment/candidates/:cid" element={<CandidateDetail />} />
        <Route path="training" element={<TrainingDashboard />} />
        <Route path="training/plans/:pid" element={<TrainingPlanDetail />} />
        <Route path="my-training" element={<MyTraining />} />
        <Route path="assets" element={<AssetDashboard />} />
        <Route path="assets/register" element={<AssetRegister />} />
        <Route path="my-assets" element={<MyAssets />} />
        <Route path="visitors" element={<VisitorLog />} />
        <Route path="travel" element={<TravelDashboard />} />
        <Route path="travel/requests" element={<TravelRequests />} />
        <Route path="travel/requests/:rid" element={<TravelRequestDetail />} />
        <Route path="my-travel" element={<MyTravel />} />
      </Routes>
    </div>
  );
}
